module.exports = __webpack_public_path__ + "static/media/login-mobile-bg.78b7b64a.svg";